<template>
  <div style="padding-top:10px;height:auto;">

    <iframe id='mainFrame' name='mainFrame' ref='mainFrame' src="http://175.27.191.97:8088/" scrolling="no" width="100%"></iframe>

  </div>
</template>

<script>
export default {
  data() {
    return {
      user: "",
      userID: "",
    }
  },
  methods: {

  },
  watch: {
  },
  mounted() {
  }
}
</script>

<style lang="less">
#mainFrame {
  width: 100%;
  height: 900px;
}
</style>